import * as React from "react";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";

import { SraQuestionnaire } from "./sraQuestionnaire";
import { Home } from "./home";

import { EmployeeSraSummary } from "./sraSurveyResult/components/EmployeeSraSummary";
import { Wrapper } from "./Wrapper";

export const App = () => {
    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route path="/" element={<Wrapper />}>
                <Route index element={<Home />} />
                <Route path="/customer/:customerId/stressriskassessment/:completionRequestId" element={<SraQuestionnaire />} />
                <Route path="/customer/:customerId/stressriskresults/:completionRequestId" element={<EmployeeSraSummary />} />
            </Route>
        ));

    return <RouterProvider router={router} />;
};
